import { render, staticRenderFns } from "./checkoutV5.vue?vue&type=template&id=08cb260a&scoped=true"
import script from "./checkoutV5.vue?vue&type=script&lang=js"
export * from "./checkoutV5.vue?vue&type=script&lang=js"
import style0 from "./checkoutV5.vue?vue&type=style&index=0&id=08cb260a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb260a",
  null
  
)

export default component.exports